const close = document.querySelectorAll('[data-behaviour="close-notice"]');
close.forEach(el => {
	el.addEventListener('click', function () {
		const parent = el.closest('[data-ref="notice"]');
		if(parent) parent.classList.add('u-hidden');
	});
});